export function setCookie(
  name: string,
  value: string | number | boolean,
  days = 7,
  path = "/",
): void {
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  document.cookie =
    name +
    "=" +
    encodeURIComponent(value) +
    "; expires=" +
    expires +
    "; path=" +
    path;
}

function parseValue(value: string): string | number | boolean | undefined {
  if (typeof value === "string" && value.length > 0) {
    // true
    if (value === "true") {
      return true;
    }
    // false
    else if (value === "false") {
      return false;
    }
    // number
    else if (!isNaN(parseInt(value))) {
      return parseInt(value);
    }
    // string
    else if (value !== "undefined" && value !== "null") {
      return value;
    }
  }

  return undefined;
}

export function getRawCookies(name: string): string[] {
  return document.cookie
    .split("; ")
    .filter((v) => v.startsWith(`${name}=`))
    .flatMap((v) => {
      // decodeURIComponent throws on an invalid %-sequence, so skip only that
      // value and keep the valid ones
      try {
        return [decodeURIComponent(v.slice(name.length + 1))];
      } catch {
        return [];
      }
    });
}

export function getRawCookie(name: string): string {
  const values = getRawCookies(name);
  return values[values.length - 1] ?? "";
}

export function getCookie(name: string): string | number | boolean | undefined {
  return parseValue(getRawCookie(name));
}
